import GdControl from "./GdControl";
import {Select} from "ol/interaction";
import {click, pointerMove} from "ol/events/condition";
import {gdAdresseGefoerdertSelectStyle, gdAdresseGefoerdertStyle, gdHidePopup, gdShowPopup} from "../gd-ol-functions";

let gdFeatureSelect;

export class GdFeatureInfoControl {

    constructor(map, layer) {
        this.map = map;
        this.layer = layer;

        this.getInteraction();
    }

    getInteraction() {
        if (gdFeatureSelect !== null) {
            this.map.removeInteraction(gdFeatureSelect);
        }

        gdFeatureSelect = new Select({
            condition: click,
            layers: [this.layer],
            style: gdAdresseGefoerdertSelectStyle
        });
        this.map.addInteraction(gdFeatureSelect);

        let this_ = this;
        gdFeatureSelect.on('select', function () {
            this_.getFeatureInfo_();
        })
    }

    getFeatureInfo_ = function () {
        let feature = gdFeatureSelect.getFeatures().getArray()[0];
        if (typeof feature !== 'undefined') {
            let coordinates = feature.getGeometry().getCoordinates();

            let html = feature.get('strasse') + '<br>' + feature.get('ort') + '<br>' + feature.get('ortsteil') + '<br>' + feature.get('fpiii');

            gdShowPopup(coordinates[0], 'Info zur Geförderten Adresse', html);
        } else {
            gdHidePopup();
        }
    }
}
export default GdFeatureInfoControl;